import { ALL_DATA_MANAGEMENT_MNEMONICS } from 'constants/mnemonicsMapping';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WellboreOutlierDTO } from 'types/outlierDto';

import styles from './Outlier.module.scss';

interface Props {
  outlier?: WellboreOutlierDTO;
}

const Outlier: React.FC<Props> = ({ outlier }) => {
  const getFormattedOutlier = (mnemonic: string) => {
    if (outlier && outlier[mnemonic]) {
      const outlierRateDisplayed = Math.round(outlier[mnemonic].outliersRate * 100);
      const isWarningRate = outlierRateDisplayed >= 1;
      const isWarningCount = outlier[mnemonic].outliers >= 15;
      const outlierCount = outlier[mnemonic].outliers > 1000 ? '>1000' : outlier[mnemonic].outliers;

      return (
        <>
          {!isNaN(outlierRateDisplayed) && (
            <div>
              <span className={isWarningRate ? styles.warningText : styles.validText}>
                {outlierRateDisplayed}
              </span>
              <FormattedMessage id="dataManagement.dataQuality.outlier.rateTimeLapse" />
            </div>
          )}
          {outlierCount !== undefined && (
            <div>
              <span className={isWarningCount ? styles.warningText : styles.validText}>
                {outlierCount}
              </span>
              <FormattedMessage id="dataManagement.dataQuality.outlier.countTimeLapse" />
            </div>
          )}
        </>
      );
    }
  };

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th />
        </tr>
      </thead>
      <tbody>
        {ALL_DATA_MANAGEMENT_MNEMONICS.map(mnemonic => (
          <tr key={mnemonic}>
            <td className={styles.outlier}>{getFormattedOutlier(mnemonic)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Outlier;
